export class ConfirmationConfig {
  title: string;
  question: string;
  explanation: string;
  cancel: string;
  confirm: string;
  isConfirmationNegative: boolean;
  onConfirm: () => Promise<void>;
}
